<template>
  <v-container fluid>
    <v-layout row>
      <v-flex>
        <v-card>
          <v-card-title primary-title class="primary white--text headline">
            Users
            <v-spacer></v-spacer>
            <v-btn medium depressed flat icon color="white" to="users/add">
              <v-icon medium>add_circle_outline</v-icon>
            </v-btn>
          </v-card-title>
          <v-divider></v-divider>
          <v-card-text class="pa-0">
            <v-data-table
            :headers="headers"
            :items="items"
            :rows-per-page-items="[10,25,50,100,{'text':'$vuetify.dataIterator.rowsPerPageAll','value':-1}]"
            :loading="usersLoading">
              <v-progress-linear slot="progress" color="primary" indeterminate></v-progress-linear>
              <template slot="items" slot-scope="props">
                <td>{{ props.item.id }}</td>
                <td>{{ props.item.username }}</td>
                <td>{{ `${props.item.firstName} ${props.item.lastName}` }}</td>
                <td>{{ props.item.email }}</td>
                <td>
                  <v-chip
                  class="white--text"
                  small
                  v-for="(role, i) in props.item.roles" :key="i"
                  color="accent">
                    {{ roleCollection[role] ? roleCollection[role].Name : `unknown role (${role})` }}
                  </v-chip>
                </td>
                <td>
                  <v-switch
                    hide-details
                    v-model="props.item.isActive"
                    :color="props.item.hasUser ? 'error' : 'success'"
                    :disabled="props.item.username==='system'"
                    @change="userActiveStatusChanged(props.item)"
                  >
                  </v-switch>

                </td>
                <!-- <td><v-icon medium :color="props.item.isActive ? 'success' : 'error'"> {{ props.item.isActive ? 'check_circle_outline' : 'remove_circle_outline' }} </v-icon></td> -->
                <td>{{ props.item.createdDate | formatDate }}</td>
                <td class="text-xs-right">
                  <v-tooltip bottom color="accent">
                    <v-icon
                      class="mr-2"
                      color="accent"
                      slot="activator"
                      @click="$router.push(`/users/${props.item.id}/edit`)"
                    >
                      edit
                    </v-icon>
                    <span>Edit Item</span>
                  </v-tooltip>
                  <v-tooltip bottom color="error">
                    <v-icon
                      color="error"
                      slot="activator"
                      @click="dialog = true; itemToDelete = props.item;"
                    >
                      delete
                    </v-icon>
                    <span>Delete Item</span>
                  </v-tooltip>
                </td>
              </template>
            </v-data-table>
          </v-card-text>
        </v-card>
      </v-flex>
    </v-layout>
    <v-dialog
    v-model="dialog"
    max-width="500"
    >
      <v-card>
        <v-card-title class="headline">Delete user</v-card-title>
        <v-card-text>
          Are you sure to delete this user?
        </v-card-text>
        <v-card-actions style="background: hsl(0, 0%, 97%)" class="pa-3">
          <v-spacer></v-spacer>
          <v-btn
            color="grey darken-1"
            flat
            depressed
            :disabled="deleteLoading"
            @click="dialog = false; itemToDelete = {};"
          >
            Cancel
          </v-btn>
          <v-btn
            color="error"
            depressed
            class="white--text"
            :loading="deleteLoading"
            :disabled="deleteLoading"
            @click.native="deleteItem()"
          >
            Delete
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import { mapState } from 'vuex'

export default {
  data () {
    return {
      headers: [
        {text: 'ID', sortable: true, value: 'id'},
        {text: 'Username', sortable: true, value: 'username'},
        {text: 'Name', sortable: true, value: 'firstName'},
        {text: 'E-Mail', sortable: false, value: 'email'},
        {text: 'Roles', sortable: false, value: 'roles'},
        {text: 'Active', sortable: false, value: 'isActive'},
        {text: 'Created', sortable: true, value: 'createdDate'},
        {text: 'Actions', value: 'name', sortable: false, align: 'right'}
      ],
      items: [],
      dialog: false,
      logsToShow: [],
      itemToDelete: {},
      deleteLoading: false,
      usersLoading: false,
      pagination: {
        sortBy: 'id'
      }
    }
  },
  created () {
    this.usersLoading = true
    this.fetchDatasets()
  },
  computed: {
    ...mapState({
      roleCollection: state => state.configurations.roles
    })
  },
  methods: {
    fetchDatasets () {
      this.axios.get('/users')
        .then(response => {
          if (response.data) {
            this.items = response.data.map(user => ({
              id: user.id,
              firstName: user.FirstName,
              lastName: user.LastName,
              email: user.Email,
              phoneNumber: user.PhoneNumber,
              username: user.Username,
              createdDate: user.CreatedDate,
              roles: user.Roles,
              isActive: user.IsActive
            }))
          }
        })
        .catch(error => {
          this.handleAxiosError(error)
        })
        .finally(() => {
          this.usersLoading = false
        })
    },
    deleteItem () {
      this.deleteLoading = true
      this.axios.delete(`/users/${this.itemToDelete.id}`)
        .then(response => {
          let index = this.items.indexOf(this.itemToDelete)
          this.items.splice(index, 1)
        })
        .catch(error => {
          this.handleAxiosError(error)
        })
        .finally(() => {
          this.deleteLoading = false
          this.dialog = false
          this.itemToDelete = {}
        })
    },
    userActiveStatusChanged (item) {
      this.axios.patch(`/users/${item.id}`, {
        is_active: item.isActive
      })
        .then(response => {
          this.$toast.open({
            text: item.isActive ? 'Activated' : 'Deactivated',
            type: 'success'
          })
        })
        .catch(error => {
          this.handleAxiosError(error)
        })
    }
  }
}
</script>

<style>

</style>
